import { render, staticRenderFns } from "./DevicesMonthPriceStats.vue?vue&type=template&id=abfbf964&scoped=true&"
import script from "./DevicesMonthPriceStats.vue?vue&type=script&lang=js&"
export * from "./DevicesMonthPriceStats.vue?vue&type=script&lang=js&"
import style0 from "./DevicesMonthPriceStats.vue?vue&type=style&index=0&id=abfbf964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfbf964",
  null
  
)

export default component.exports